import { SxProps, Theme } from '@mui/system';
import { ReactNode } from 'react';


export interface ConfimationMessageProps {
    success?: boolean;
    needForTG?: boolean;
    wrapperSx?: SxProps<Theme>;
    mainBlockSx?: SxProps<Theme>;
    secondaryTextSx?: SxProps<Theme>;
    messageTranslation: string;
    customErrorHelper?: ReactNode;
}


export const TELEGRAM_LINK = 'https://t.me/cfa_hub';
